import React, { useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import Dropdown from "../Dropdown";

const SectionItemSelectRegionWithAdd = ({ item, column, onPropChange }) => {
  const { t } = useTranslation();

  const [state, setState] = useState({
    comboValue: {},
  });
  const [sourceRegion, setSourceRegion] = useState(null);
  const [applyToBothDirections, setApplyToBothDirections] = useState(true);

  const handleOnButtonClick = () => {
    const { comboValue } = state;
    const items = item[column.accessor] || [];

    if (column.isReadonly) {
      return;
    }

    if (onPropChange && comboValue && (comboValue["key"] !== undefined)) {
      onPropChange({
        [column.accessor]: items.concat([{
          ...comboValue,
          sourceRegionId: sourceRegion?.id || null,
          sourceRegionName: sourceRegion?.name || null,
          applyToBothDirections,
        }])
      });
      setState({ comboValue: {} });
      setApplyToBothDirections(true);
      setSourceRegion(null);
    }
  };

  const handleOnSourceRegion = (val) => {
    setSourceRegion(val);
    setState({ comboValue: {} });
  }

  const handleOnSelect = val => {
    if (column.irReadonly) {
      return
    }

    setState({ comboValue: val })
  }

  const geyFilteredToValue = () => {
    const itemValues = item.regionConfigurations;

    const id = sourceRegion?.id || null;

    const emptyFromIds = itemValues.filter(reg => reg.sourceRegionId === id).map(reg => reg.id);
    return values.filter(region => !emptyFromIds.includes(region.id));
  }

  const values =
    typeof column.values === "function"
      ? column.values(item) || []
      : this.props.values || [];

  return (
    <div
      key={`sectionItemSelectWithAdd-${column.accessor}`}
      className={classNames("sectionItemSelectRegionWithAdd")}
    >
      <div className={classNames("sectionItemSelectWithAddContainer")}>

        <div className="regionAddItem">
          <div className="title">{t("settings.map.DEPOT_FIX_DELIVERY_PRICE_FROM_LABEL")}</div>
          <Dropdown
            values={[{key: null, value: '-'}].concat(values)}
            labelField="value"
            valueField="key"
            readonly={column.isReadonly}
            searchBy="value"
            value={sourceRegion?.["value"] || ""}
            onSelect={handleOnSourceRegion}
          />
        </div>
        <div className="regionAddItem">
          <div className="title">{t("settings.map.DEPOT_FIX_DELIVERY_PRICE_TO_LABEL")}</div>
          <Dropdown
            values={geyFilteredToValue()}
            labelField="value"
            valueField="key"
            readonly={column.isReadonly}
            searchBy="value"
            value={state.comboValue["value"] || ""}
            onSelect={val => handleOnSelect(val)}
          />
        </div>
        <div
          className={classNames("sectionItemSelectButton", "btn", "denied")}
          onClick={handleOnButtonClick}
        >
          {t("basic.ADD_BUTTON")}
        </div>
      </div>
      {sourceRegion && (
        <div className={classNames("checkboxContainer", { selected: applyToBothDirections })} onClick={() => setApplyToBothDirections(!applyToBothDirections)}>
          <span>{t("settings.map.DEPOT_FIX_DELIVERY_PRICE_BOTH_DIRECIONS_LABEL")}</span>
          <div className="checkboxBlock">✓</div>
        </div>
      )}
    </div>
  );
}

export default withTranslation()(SectionItemSelectRegionWithAdd);
